<template>
  <div style="width:100vw; height: 100vh">
    <cmdp-writer-follow domain="https://a.cmdp.cn" label="小智仿写" ></cmdp-writer-follow>
  </div>
</template>

<script>
export default {
  name: "readerTransfer",
  data() {
	  return {
			yearConfigs: {
				'default' : {
					year: "default",
					catlogPbcId: "api000134",
					recognPbcId: "file_no_arg_recognize",
					verifyPbcId: "api000311",
					tempHtmlPath: "usys/factory/factor/template/release/1676513097003651074/pzi9qe90gm4kueb68kiiebo8vg6dkorm.html",
					tempViewPath: "usys/factory/factor/template/release/1676513097003651074/18ec829a-b41d-44e8-b30f-9b34e17114db.json",
					tempCatlogPath: "usys/factory/factor/template/release/1676513097003651074/px8hc2xuiriuerwcprxcjhlt629p8d89.json",
					exportWordPbcId: "api000217",
					exportRfPbcId: "api000218",
				},
				'2022': {
					year: "2022",
					catlogPbcId: "api000134",
					recognPbcId: "file_no_arg_recognize",
					verifyPbcId: "api000311_2022",
					tempHtmlPath: "usys/factory/factor/template/release/1684480959465607169/y6yzlhijrajrbu6q2wm1cdtikb3wmydl.html",
					tempViewPath: "usys/factory/factor/template/release/1684480959465607169/c544c408-e947-4f38-b099-c91144ea332c.json",
					tempCatlogPath: "usys/factory/factor/template/release/1684480959465607169/a11kuhg05xu0gn1y55d1fjei2n3c6f8b.json",
					exportWordPbcId: "api000217",
					exportRfPbcId: "api000218_2022",
				},

			}
	  }
  },
  created() {
    sessionStorage.setItem( "USER_TOKEN_VAL", "36a8ba57-3edd-49ff-a83f-990885da8897" );
  }
}
</script>

<style scoped>

</style>
